import { interpret } from 'xstate-v4'
import { UserStoredCardsRepositoryFetch } from './UserStoredCardsRepositoryFetch'
import { userStoredCardMachine } from './machines/UserStoredCardMachine'
import { returnUserStoredCardsMachine } from './machines/UserStoredCardsMachine'

export function getUserStoredCardsMachine(langCode: string | string[]) {
  const cardMachine = userStoredCardMachine.withConfig({
    services: {
      removeCard: async (context) => {
        return await new UserStoredCardsRepositoryFetch().delete(
          context.id,
          langCode,
        )
      },
    },
  })
  const userStoredCardsMachine = returnUserStoredCardsMachine()
  return interpret(
    userStoredCardsMachine
      .withContext({ ...userStoredCardsMachine.context, cardMachine })
      .withConfig({
        services: {
          getCards: () =>
            new UserStoredCardsRepositoryFetch().readAll(langCode),
        },
      }),
  )
}
